import {Component, Inject, OnInit } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Observable} from "rxjs";
import {Store} from "@ngrx/store";
import { take } from 'rxjs/operators';
import {RfqModalModule} from './rfq-modal.module';
import {AuthService, CodescService, PageNotificationService} from '@signature-it/ngx-generic/services';
import { GenericConfig } from '@signature-it/ngx-generic/config';
import {IUser} from '@signature-it/ngx-generic/interfaces';
import {FormControl, UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {CodescDTO} from '@signature-it/ngx-generic/models';
import {RfqService} from '../../../services/rfq.service';


declare let _: any;
interface IRfqData {
    pid: number;
    sku: string;
    skuText: string;
}

@Component({
    selector: 'rfq-modal',
    templateUrl: './rfq-modal.html',
    styleUrls: ['./rfq-modal.scss'],
    standalone: false
    //encapsulation: ViewEncapsulation.None
})

export class RfqModalComponent implements OnInit{

    user: IUser;
    form: UntypedFormGroup;
    isLoaded = false;
    countries$;
    segments$;
    subSegments$;
    searchText = new FormControl('');
    submitSpinner: boolean = false;
    rfqRedirect: string = GenericConfig.getValue('rfqRedirect') || null;

    constructor(public dialogRef: MatDialogRef<RfqModalComponent>,
                @Inject(MAT_DIALOG_DATA) public data: IRfqData,
                protected store$: Store<any>,
                protected authService: AuthService,
                protected fb: UntypedFormBuilder,
                protected codescSvc: CodescService,
                protected notifySvc: PageNotificationService,
                protected rfqSvc: RfqService) {
    }

    ngOnInit() {
        this.authService.usersData$
            // .pipe(take(1))
            .subscribe((user: IUser) => {
            this.user = user;
            this.buildRfqForm();
            this.getFormData();
            this.isLoaded = true;
        });
    }

    buildRfqForm() {
        this.form = this.fb.group({
            pid: [this.data.pid],
            pcode: [this.data.sku],
            quantity: [1, Validators.required],
            unit: ['km', Validators.required],
            comment: [''],
            user: this.user.isGuest() ? this.userForm() : {}
        });
    }

    userForm() {
        return this.fb.group({
            first_name: ['', [Validators.required]],
            last_name: ['', [Validators.required]],
            user_company: ['', [Validators.required]],
            user_email: ['', [Validators.required, Validators.email]],
            user_phone: ['', [Validators.pattern(/\d/), Validators.minLength(6), Validators.maxLength(12)]],
            user_country: ['', [Validators.required]],
            newsletter: [false],
            c_r1: ['', [Validators.required]]//segment
            // c_r2: ['']//subSegment
        });
    }

    getFormData() {
        this.countries$ = this.codescSvc.getByVarOnce('country');
        this.segments$ = this.codescSvc.getByVarOnce('teldor_segment');
        // this.subSegments$ = this.codescSvc.getByVarOnce('teldor_subsegment');
    }

    submitForm() {
        if (this.form.valid) {
            this.submitSpinner = true;
            this.rfqSvc.rfq(this.form.value).subscribe(
                res => {
                    this.submitSpinner = false;
                    this.notifySvc.set('RFQ Created Successfully', 200).show();
                    this.dialogRef.close();
                    if(this.rfqRedirect) {
                        this.authService.handleAuthentication(this.rfqRedirect);
                    }
                },
                error => {
                    this.submitSpinner = false;
                    this.notifySvc.set(error.error).show();
                }
            );
        } else {
            this.form.markAllAsTouched();
        }
    }

    onClose(): void {
        this.dialogRef.close();
    }
}
